export const ProductDetailsModalComponent: ng.IComponentOptions = {
  bindings: {
    product: '<',
    defaultCurrency: '<',
    onClose: '&',
  },
  templateUrl: 'products/modals/product-details/product-details-modal.html',
};
